import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { showErrorToast } from "#app/notifications";
import {
  downloadMaterialConsultationCsv,
  NoMaterialLinesError,
} from "#modules/quoteRequests/infra/downloadMaterialConsultationCsv.api";
import { QuoteRequestAtom } from "#shared/view/components/AppShell/Atoms";

export const useMaterialConsultationCsvDownload = (quoteRequest: QuoteRequestAtom) => {
  const { t } = useTranslation();

  const canDownload =
    !!quoteRequest && quoteRequest.quoteRequestLines.some((line) => !!line.layout?.materialLayout);

  const { mutate, isPending } = useMutation({
    mutationFn: downloadMaterialConsultationCsv,
    onError: (err) => {
      if (err instanceof NoMaterialLinesError) {
        showErrorToast({
          title: t("quoteRequestLine.actions.exportConsultation.modal.noMaterialLines"),
          color: "yellow",
        });
        return;
      }

      showErrorToast({
        title: t("quoteRequestLine.actions.exportConsultation.modal.downloadError"),
      });
    },
  });

  const downloadCsv = () => {
    if (!quoteRequest) {
      return;
    }

    mutate({ quoteRequestId: quoteRequest.id, reference: quoteRequest.reference });
  };

  return { downloadCsv, canDownload, isDownloading: isPending };
};
